const FONTS_CDN = 'fonts-cdn.bureau.ru'

const fontsRoot = process.env.NODE_ENV === 'production' ? `https://${FONTS_CDN}/1.16` : '/fonts'

module.exports = fontsRoot
